/* global jQuery, js_vars, elementorFrontend */

/*--------------------------------------------------------------------------------
General Ready
--------------------------------------------------------------------------------*/
( function( $ ) {
$(document).ready(function(){

	/*--------------------------------------------------------------------------------
	Utility: Hide element on click outside
	--------------------------------------------------------------------------------*/
	
	function hideOnClickOutside( selector, type = 'standard' ) {
		const outsideClickListener = (event) => {
			const $target = $(event.target);
			if ( ! $target.closest(selector).length ) {
				$(selector).removeClass('open');
				if ( type == 'menu' ) {
					$('#site-header').removeClass('active');
				}
				removeClickListener();
			}
		}

		const removeClickListener = () => {
			document.removeEventListener('click', outsideClickListener)
		}
		
		document.addEventListener('click', outsideClickListener)
	}

	/*--------------------------------------------------------------------------------
	Gravity Forms
	--------------------------------------------------------------------------------*/

	// Move progress indicator to gform footer
	$('.gform_page_footer').append( $('.gf_progressbar_wrapper') );
	$(document).on('gform_page_loaded', function(event, form_id, current_page){
		$('.gform_page_footer').append( $('.gf_progressbar_wrapper') );	
	});

} );
} )( jQuery );
